import { useTranslation } from 'react-i18next'

import { ErrorPage } from '@liveconnect/components'

import { Main } from '../../../components/Main'

const NotAvailable = () => {
  const { t } = useTranslation()

  return (
    <Main ariaLabelledby="page-not-available">
      <ErrorPage className="page-error-not-available">
        <>
          <ErrorPage.Icon name="report_problem" />
          <ErrorPage.Title text={t('pageError.notAvailable.title')} />
          <ErrorPage.Body text={t('pageError.notAvailable.body')} />
        </>
      </ErrorPage>
    </Main>
  )
}

export default NotAvailable
